export default function getUrlPath(url: string) {
  if (!url) return '';
  const found = url.match(/^.*:?\/\/[\w.-]+(:\d+)?(\/[\w-/]+)\??/);
  return found ? found[2] : '';
}
